import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import { useFlags } from 'launchdarkly-react-client-sdk';

// Constants
import PageUrls from 'Shared/constants/PageUrls.constants';

// Components
import CreateOrUpdateGoalPageV2 from '../CreateOrUpdateGoalPage/CreateOrUpdateGoalPageV2';

const CreateOrUpdateGoalPageWrapper = () => {
  const history = useHistory();
  const { featureFlagGoalsVersion3: showNewGoals } = useFlags();

  useEffect(() => {
    if (showNewGoals) history.push({ pathname: PageUrls.GOALS_PAGE, search: '?show=new' });
  }, [showNewGoals]);

  if (showNewGoals) {
    return null;
  } else return <CreateOrUpdateGoalPageV2 />;
};

export default CreateOrUpdateGoalPageWrapper;
